import { render, staticRenderFns } from "./BookingsView.vue?vue&type=template&id=1b702cac&scoped=true"
import script from "./BookingsView.vue?vue&type=script&lang=js"
export * from "./BookingsView.vue?vue&type=script&lang=js"
import style0 from "./BookingsView.vue?vue&type=style&index=0&id=1b702cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b702cac",
  null
  
)

export default component.exports